<template>
  <fragment>
    <label>Verification Mode:</label>
    <app-input class="col-sm-8"
               type="select"
               :list="verificationList"
               v-model="selectedVerification"
               :disabled="isSelectedDisabled"
               :required="true"
               v-on:change="verificationOnChange"
    />


    <br>
    <label>Select Action:</label>
    <app-input class="col-sm-8"
               type="select"
               :list="dynamicSteps"
               v-model="selectedStep"
               :required="true"/>
    <label>Action Comment:</label>
    <div v-if="showWrittenHelpText" class="help-text">
      <div class="help-content">
        <strong>📢 Important Information:</strong>
        <p>Below is the template, Please tailor it according to your requirement. </p>
        <p>
          The email will be sent based on the selected action. If needed, the URL can be shared separately through the comments section.
        </p>
        <p>Please ensure that the recipient has access to the provided link if shared separately.</p>
      </div>
      <button class="close-btn" @click="showWrittenHelpText = false">✖</button>
    </div>

    <app-input class="col-sm-8"
               type="text-editor"
               v-model="commentText"
               placeholder="Write Comment"
               :required="true"/>
    <multi-upload-btn
        :uploadedFile="this.uploadedFile"
        :emailAddress="this.emailAddress"
    />
<!--    <template v-if="selectedVerification === 'written'">-->


<!--      &lt;!&ndash; <el-button class="secondary float-left ml-3 mt-2"-->
<!--                 @click="sendEmail()">-->
<!--        Send Email-->
<!--      </el-button> &ndash;&gt;-->
<!--    </template>-->
    <el-button class="secondary float-left ml-3 mt-2"
               @click="saveComment()">
      Save Comment
    </el-button>
  </fragment>
</template>

<script>
import {
  dateFormatter,
  pushStepIntoSpecificIndex
} from "@Views/Screening/utility/common";
import {
  _status,
  verificationList,
  oralSteps,
  writtenSteps
} from '@Views/Screening/utility/constant';
import {updateCommentSteps} from "@Views/Screening/utility/common/comment";
import {Comment} from "@Views/Screening/utility/apiAgent";

export default {
  name: "CustomizedComments",
  props: {
    applicantId: {
      type: Number
    },
    statusable_type: {
      type: String
    },
    statusable_id: {
      type: Number
    },
    emailAddress: {
      type: String
    },
    comment: {
      type: Array
    },
    steps: {
      type: Array
    },
    history: {
      type: Object
    }
  },
  data() {
    return {
      comments: [],
      status: '',
      emailText: '',
      selectedVerification: '',
      uploadedFile: [],
      dynamicSteps: [],
      commentText: '',
      selectedStep: '',
      isSelectedDisabled: false,
      showCommentList: false,
      commentList: [],
      verificationList: verificationList,
      statusList: _status,
      oralSteps: oralSteps,
      writtenSteps: writtenSteps,
      showWrittenHelpText: false,

    }
  },
  watch:{
    statusable_type: 'checkStatusableType'
  },
  computed:{
    historyType(){
      return this.statusable_type
    }
  },
  mounted(){
    this.checkStatusableType();

  },
  methods: {
    dateFormatter,
    pushStepIntoSpecificIndex,
    updateCommentSteps,
    checkStatusableType(){
      if (this.historyType === 'App\\Models\\Screening\\ApplicantUnemployment' || this.historyType === 'App\\Models\\Screening\\ApplicantEducation'){
        this.selectedVerification = 'general';
        this.verificationOnChange();
      }else{
        this.selectedVerification = '';
      }
    },
    saveComment() {
      if (this.commentText != '') {
        const commentObj = {
          statusable_type: this.historyType,
          statusable_id: this.statusable_id,
          status: this.selectedStep,
          status_type: this.selectedVerification,
          action_comment: this.commentText,
          applicant_files: this.uploadedFile.map(x => x.id)
        };
        Comment.saveComment(this.applicantId, commentObj)
            .then(({data}) => {
              this.comments.push({id: data.screeningStatus.id, ...commentObj});
              this.updateCommentSteps({id: data.screeningStatus.id, ...commentObj}, false);
              this.selectedStep = '';
              this.selectedVerification = '';
              this.uploadedFile.splice(0);
              this.$hub.$emit('clear-uploaded-files');
              this.commentText = '';
              this.$toastr.s(data.message);
            });
      }
    },
    verificationOnChange() {
      this.dynamicSteps = [];
      this.isSelectedDisabled = false;
      this.dynamicSteps.push({id: 'select', value: 'Select Step'});
      if (this.selectedVerification === 'oral') {
        this.dynamicSteps.push(...this.oralSteps);

        this.commentText = this.setFormattedText();

      } else if (this.selectedVerification === 'general'){
        this.isSelectedDisabled = true;
        this.dynamicSteps.push(...this.statusList);
      }
      else {
        this.showWrittenHelpText = true;
        this.commentText = this.setFormattedText();
        this.dynamicSteps.push(...this.writtenSteps);
      }
    },
    setFormattedText() {
      return `
        <p><b>Dates Employed (as stated by previous employer)</b> <br>
        From: <u>${this.history.start_date_formatted || "N/A"}</u> &nbsp;&nbsp;
        To: <u>${this.history.end_date_formatted || "N/A"}</u></p>

        <p><b>Dates Employed (as stated by applicant)</b> <br>
        From: <u>${this.history.start_date_formatted || "N/A"}</u> &nbsp;&nbsp;
        To: <u>${this.history.end_date_formatted || "N/A"}</u></p>

        <p><b>Reason(s) for leaving (as stated by previous employer)</b> <br>
        ${this.history.employer_reason || "Not provided"}</p>

        <p><b>Reason(s) for leaving (as stated by the applicant)</b> <br>
        ${this.history.reason_for_leaving || "Not provided"}</p>

        <p><b>Was the applicant:</b> <br>
        Honest and Trustworthy: <u>${this.history.honest ? "Yes" : "No"}</u> &nbsp;&nbsp;
        Good Timekeeper: <u>${this.history.timekeeper ? "Yes" : "No"}</u></p>

        <p><b>Would you re-employ?</b> <br>
        ${this.history.reemploy ? "Yes" : "No"} &nbsp;&nbsp;
        If not, why not?<br>
        ${this.history.reemploy_reason || "Not provided"}</p>

        <p><b>Full address of Previous Employer (for written confirmation)</b> <br>
        ${this.history.company_address || "Not provided"}</p>

        <p><b>Tel No.:</b> ${this.history.contact_number || "N/A"} &nbsp;&nbsp;
        <b>Email:</b> ${this.history.contact_email || "N/A"}</p>

        <p><b>Comments:</b><br>
        ...</p>
    `;

    }

  }
}
</script>

<style scoped>

</style>